/**
 * Atribución de tráfico por UTM (primer contacto). Las mismas reglas valen en
 * el cliente (lectura de la URL) y en el servidor (validación al guardar).
 */
export const ACQ_SOURCES = ["tiktok", "instagram", "facebook", "youtube", "whatsapp", "x", "otro"] as const;
export type AcqSource = (typeof ACQ_SOURCES)[number];

export const CAMPAIGN_PATTERN = /^[a-z0-9-]{1,64}$/;

/** Días que dura el primer contacto guardado en el navegador. */
export const FIRST_TOUCH_DAYS = 7;

export interface Attribution {
  source: AcqSource;
  campaign: string;
}

/** Devuelve la atribución solo si fuente y campaña son válidas; si no, null. */
export function parseAttribution(source: unknown, campaign: unknown): Attribution | null {
  if (typeof source !== "string" || typeof campaign !== "string") return null;
  if (!(ACQ_SOURCES as readonly string[]).includes(source)) return null;
  if (!CAMPAIGN_PATTERN.test(campaign)) return null;
  return { source: source as AcqSource, campaign };
}
